module.exports = __webpack_public_path__ + "img/banner1.d2de3c6c.jpg";